<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3f7O88/tc-custom/9781632163462.jpg?1700881960838" alt="This image is the cover for the book Desert World Allegiances, Desert World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Desert World Allegiances, Desert World
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Desert World: Book One</i></b></p><p>Livre once offered Planetary Alliance miners and workers a small fortune if they helped terraform the mineral rich planet. People flocked to the world, but then a civil war cut the desert planet off from all resources.  Half-terraformed and clinging to the edge of existence, Livre devolved into a world where death was accepted as part of life, water resources were scarce and constantly dwindling, and neighbors tried to help each other hold off the inevitable as the desert fought to take back the few terraformed spaces.</p> <p>Temar Gazer claims to be the victim of water theft.  His claims could be a simple misdirection intended to help him escape a term of labor after his criminal prank caused irreparable damage to a watering system.  However as the only member of the council arguing against a short-term slavery sentence for Temar, Shan Polli can’t escape the fear that something darker is happening. The more he investigates Temar’s story, the more he finds that his world is not as free of politics or danger as he had assumed. Together, Shan and Temar must get to the bottom of the conspiracy before time runs out for the entire planet.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lyn Gala
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a3134bb